module.exports = __webpack_public_path__ + "img/404.2ea7bb50.png";